module.exports = __webpack_public_path__ + "media/images/bg/shapes/individual-courses-91a0bc5ca1ea5d18e6d3b996fee77ff7.svg";